import {
  GET_ALL_PERMISSIONS,
  SET_PERMISSION,
  SET_PERMISSION_HELPERS
} from 'src/store/mutation-types'

export default {
  [GET_ALL_PERMISSIONS] (state, permissions) {
    state.permissions = permissions
  },
  [SET_PERMISSION] (state, permission) {
    state.permission = permission
  },
  [SET_PERMISSION_HELPERS] (state, helpers) {
    state.permissionHelpers = helpers
  }
}



// WEBPACK FOOTER //
// ./src/components/permission/store/mutations.js